export default "__VITE_ASSET__03fe5eda__"